
import React from 'react'
import './EmployeeMessage.css';

import { Link } from 'react-router-dom';

const EmployeeMessage = () => {
    return (
        <>
            <div id="Contents">
                <div className="mainHead">
                    <h1>Older Messages : </h1>
                    <div id="Allmessages">
                        <div className="messageBox">

                            {/* 1 all particular dishes show under the row */}
                            <div className="showing">

                                <div className="heads">
                                    <h2>Pendings Order Details</h2>
                                </div>
                                <div className="row">
                                    <div className="dishDetails">
                                        <div className="dishImg">
                                            <img src="/images/dosa.jpg" alt="" srcSet="" />
                                        </div>
                                        <div className="dishInfo">
                                            <div className="Name">Name :
                                                <label htmlFor=""> Pizza</label>
                                            </div>
                                            <div className="Quantity">
                                                <label htmlFor="">Qty : </label>
                                                <label htmlFor="">2</label>
                                            </div>
                                            <div className="price">
                                                <label htmlFor="">Price : </label>
                                                <label htmlFor="">120</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="operationBtn">
                                        <div className="btn">
                                            <button><Link href="www.google.com">Complete</Link></button>
                                        </div>
                                        <div className="btn">
                                            <button><Link href="www.google.com">Delete</Link></button>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            {/* 2 all particular dishes show under the row */}
                            <div className="showing">

                                <div className="heads">
                                    <h2>Pendings Order Details</h2>
                                </div>
                                <div className="row">
                                    <div className="dishDetails">
                                        <div className="dishImg">
                                            <img src="/images/dosa.jpg" alt="" srcSet="" />
                                        </div>
                                        <div className="dishInfo">
                                            <div className="Name">Name :
                                                <label htmlFor=""> Pizza</label>
                                            </div>
                                            <div className="Quantity">
                                                <label htmlFor="">Qty : </label>
                                                <label htmlFor="">2</label>
                                            </div>
                                            <div className="price">
                                                <label htmlFor="">Price : </label>
                                                <label htmlFor="">120</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="operationBtn">
                                        <div className="btn">
                                            <button><Link href="www.google.com">Complete</Link></button>
                                        </div>
                                        <div className="btn">
                                            <button><Link href="www.google.com">Delete</Link></button>
                                        </div>
                                    </div>
                                </div>
                            </div>



                            {/* 3 all particular dishes show under the row */}
                            <div className="showing">

                                <div className="heads">
                                    <h2>Pendings Order Details</h2>
                                </div>
                                <div className="row">
                                    <div className="dishDetails">
                                        <div className="dishImg">
                                            <img src="/images/dosa.jpg" alt="" srcSet="" />
                                        </div>
                                        <div className="dishInfo">
                                            <div className="Name">Name :
                                                <label htmlFor=""> Pizza</label>
                                            </div>
                                            <div className="Quantity">
                                                <label htmlFor="">Qty : </label>
                                                <label htmlFor="">2</label>
                                            </div>
                                            <div className="price">
                                                <label htmlFor="">Price : </label>
                                                <label htmlFor="">120</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="operationBtn">
                                        <div className="btn">
                                            <button><Link href="www.google.com">Complete</Link></button>
                                        </div>
                                        <div className="btn">
                                            <button><Link href="www.google.com">Delete</Link></button>
                                        </div>
                                    </div>
                                </div>
                            </div>



                            {/* 4 all particular dishes show under the row */}
                            <div className="showing">

                                <div className="heads">
                                    <h2>Pendings Order Details</h2>
                                </div>
                                <div className="row">
                                    <div className="dishDetails">
                                        <div className="dishImg">
                                            <img src="/images/dosa.jpg" alt="" srcSet="" />
                                        </div>
                                        <div className="dishInfo">
                                            <div className="Name">Name :
                                                <label htmlFor=""> Pizza</label>
                                            </div>
                                            <div className="Quantity">
                                                <label htmlFor="">Qty : </label>
                                                <label htmlFor="">2</label>
                                            </div>
                                            <div className="price">
                                                <label htmlFor="">Price : </label>
                                                <label htmlFor="">120</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="operationBtn">
                                        <div className="btn">
                                            <button><Link href="www.google.com">Complete</Link></button>
                                        </div>
                                        <div className="btn">
                                            <button><Link href="www.google.com">Delete</Link></button>
                                        </div>
                                    </div>
                                </div>
                            </div>



                            {/* 5 all particular dishes show under the row */}
                            <div className="showing">

                                <div className="heads">
                                    <h2>Pendings Order Details</h2>
                                </div>
                                <div className="row">
                                    <div className="dishDetails">
                                        <div className="dishImg">
                                            <img src="/images/dosa.jpg" alt="" srcSet="" />
                                        </div>
                                        <div className="dishInfo">
                                            <div className="Name">Name :
                                                <label htmlFor=""> Pizza</label>
                                            </div>
                                            <div className="Quantity">
                                                <label htmlFor="">Qty : </label>
                                                <label htmlFor="">2</label>
                                            </div>
                                            <div className="price">
                                                <label htmlFor="">Price : </label>
                                                <label htmlFor="">120</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="operationBtn">
                                        <div className="btn">
                                            <button><Link href="www.google.com">Complete</Link></button>
                                        </div>
                                        <div className="btn">
                                            <button><Link href="www.google.com">Delete</Link></button>
                                        </div>
                                    </div>
                                </div>
                            </div>



                            {/* 6 all particular dishes show under the row */}
                            <div className="showing">

                                <div className="heads">
                                    <h2>Pendings Order Details</h2>
                                </div>
                                <div className="row">
                                    <div className="dishDetails">
                                        <div className="dishImg">
                                            <img src="/images/dosa.jpg" alt="" srcSet="" />
                                        </div>
                                        <div className="dishInfo">
                                            <div className="Name">Name :
                                                <label htmlFor=""> Pizza</label>
                                            </div>
                                            <div className="Quantity">
                                                <label htmlFor="">Qty : </label>
                                                <label htmlFor="">2</label>
                                            </div>
                                            <div className="price">
                                                <label htmlFor="">Price : </label>
                                                <label htmlFor="">120</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="operationBtn">
                                        <div className="btn">
                                            <button><Link href="www.google.com">Complete</Link></button>
                                        </div>
                                        <div className="btn">
                                            <button><Link href="www.google.com">Delete</Link></button>
                                        </div>
                                    </div>
                                </div>
                            </div>



                            {/* 7 all particular dishes show under the row */}
                            <div className="showing">

                                <div className="heads">
                                    <h2>Pendings Order Details</h2>
                                </div>
                                <div className="row">
                                    <div className="dishDetails">
                                        <div className="dishImg">
                                            <img src="/images/dosa.jpg" alt="" srcSet="" />
                                        </div>
                                        <div className="dishInfo">
                                            <div className="Name">Name :
                                                <label htmlFor=""> Pizza</label>
                                            </div>
                                            <div className="Quantity">
                                                <label htmlFor="">Qty : </label>
                                                <label htmlFor="">2</label>
                                            </div>
                                            <div className="price">
                                                <label htmlFor="">Price : </label>
                                                <label htmlFor="">120</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="operationBtn">
                                        <div className="btn">
                                            <button><Link href="www.google.com">Complete</Link></button>
                                        </div>
                                        <div className="btn">
                                            <button><Link href="www.google.com">Delete</Link></button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default EmployeeMessage
